import { render, staticRenderFns } from "./ArrowFilled.vue?vue&type=template&id=5366a9fd"
import script from "./ArrowFilled.vue?vue&type=script&lang=js"
export * from "./ArrowFilled.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports